import React, { createContext, useContext, useMemo } from "react";

const AmazonIdeaTemplateContext = createContext(null);

export function AmazonIdeaTemplateProvider({ children, ...props }) {
    const bag = useMemo(() => ({ ...props }), [...Object.values(props)]);

    return (
        <AmazonIdeaTemplateContext.Provider value={bag}>
            {children}
        </AmazonIdeaTemplateContext.Provider>
    );
}

export function useAmazonIdeaTemplateCtx() {
    return useContext(AmazonIdeaTemplateContext);
}
